import { PermissionGuard } from '@/features/auth';
import { useDealerFinancials } from '../../hooks/useDealerFinancials';
import { DealerSageMappingsSection } from '../DealerSageMappings/DealerSageMappingsSection';
import { DealerFinancials } from './DealerFinancials';
import { FundStatementPeriodSection } from './FundStatementPeriod/FundStatementPeriodSection';

interface Props {
    dealerId: string;
    includesOwnedDealers: boolean;
}

export function DealerFinancialsTab({ dealerId, includesOwnedDealers }: Props) {
    const view = useDealerFinancials(dealerId);
    return (
        <div className="space-y-6">
            <PermissionGuard permission={{ resource: 'ledger', action: 'fund-statement.read' }}>
                <FundStatementPeriodSection dealerId={dealerId} />
            </PermissionGuard>
            <DealerFinancials
                {...view}
                includesOwnedDealers={includesOwnedDealers}
                extraSections={
                    <PermissionGuard permission={{ resource: 'ledger', action: 'sage-mapping.browse' }}>
                        <DealerSageMappingsSection dealerId={dealerId} includesOwnedDealers={includesOwnedDealers} />
                    </PermissionGuard>
                }
            />
        </div>
    );
}
